import { render, staticRenderFns } from "./LayoutWizardUser.vue?vue&type=template&id=ebb8d58e"
import script from "./LayoutWizardUser.vue?vue&type=script&lang=js"
export * from "./LayoutWizardUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebb8d58e')) {
      api.createRecord('ebb8d58e', component.options)
    } else {
      api.reload('ebb8d58e', component.options)
    }
    module.hot.accept("./LayoutWizardUser.vue?vue&type=template&id=ebb8d58e", function () {
      api.rerender('ebb8d58e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/LayoutWizardUser.vue"
export default component.exports